export default __webpack_public_path__ + "static/media/campfire.9a773447.svg";